export default {
      id: "checked-circle-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#checked-circle-usage",
      toString: function () {
        return this.url;
      }
    }